const eb = require("@/services/eventBus");
const store = require("@/store").default;
const api = require("@/services/api");
const utils = require("@/utils").default;
const store_utils = require("@/store_utils").default;
const specs = require("@/specs").default;
const active_job = require("@/services/active_job");

const ss = require("@/services/socket");

import setUpMatomo from "../matomo";
import { apiRequest } from "@/services/api";
import styleProfile from "../style-profile";
import { i18n } from "../lang";
import { customLogger } from "@/utils";
import { CheckFormacastFinishConditions, Force10PointsToFinish, SesstionExpired, backToStepStarter, formacastLogicMessage } from "./formacast";
import sizeAdvice from "./size_advice/sizeAdvice";
const audio = new Audio(
  "https://storage.googleapis.com/cleed-datacenter-europe/packages/lib/notification-sound1.ogg"
);

customLogger("controller evaluated");
eb.on("BoxAuthanticated", onBoxAuthanticated);
eb.on("BoxMounted", onBoxMounted);
eb.on("BoxOpen", onBoxOpen);
eb.on("BoxClose", onBoxClose);
eb.on("BoxToggle", onBoxToggle);
eb.on("BoxSwitchMode", onBoxSwitchMode);
eb.on("DislikeModeButtonClick", onDislikeModeButtonClick);
eb.on("BoxButtonClick", onBoxButtonClick);
eb.on("BoxRestartStyleProfile", onBoxRestartStyleProfile);
eb.on("StyleButtonClick", onStyleButtonClick);

eb.on("BoxProductLike", onBoxProductLike);
eb.on("BoxProductDislike", onBoxProductDislike);
eb.on("BoxProductClick", onBoxProductClick);
eb.on("BoxImageClick", onBoxImageClick);
eb.on("StyleImageClick", onStyleImageClick);
eb.on("BoxGridSelected", onBoxGridSelected);
eb.on("StyleGridSelected", onStyleGridSelected);
eb.on("BoxSubmittedForm", onBoxSubmittedForm);
eb.on("StyleSubmittedForm", onStyleSubmittedForm);
eb.on("BoxLookingForSimilar", onBoxLookingForSimilar);

eb.on("PopUpButtonClick", onPopUpButtonClick);
eb.on("PopUpClose", onPopUpClose);

eb.on("ChatSubmitMessage", onChatSubmitMessage);

/*********lahcen tracking the input*********/
eb.on("ChatTrackingTyping", onChatTrackingTyping);
/******************/

eb.on("ChatReceiveMessage", onChatReceiveMessage);
eb.on("ChatEmailInput", onChatEmailInput);
eb.on("ChatMessageEmailInput", onChatMessageEmailInput);
eb.on("ChatSearch", onChatSearch);

eb.on("SlackMessageDeleted", onSlackMessageDeleted);
eb.on("scrollPage", onScrollPage);
eb.on("waited10s", onWaited10s);
eb.on("AddToCart", onAddToCart);

eb.on("GetCommandNumber", onGetCommandNumber);
eb.on("GetReturnNumber", onGetReturnNumber);
eb.on("CreateTicketZendesk", onCreateTicketZendesk);
eb.on("BoxUserInfo", onBoxUserInfo);
eb.on("BoxEmailMessage", onBoxEmailMessage);
eb.on("BoxEmail", onBoxEmail);

eb.on("ShopifyFollowOrder", onShopifyFollowOrder);
eb.on("SendEmailBrand", onSendEmailBrand);

eb.on("UpdateChatConfig", onUpdateChatConfig);

eb.on("SkipEmailMessage", onSkipEmailMessage);

eb.on("BoxQcmResult", onBoxQcmResult);

//#region Formacast
eb.on("BoxCheckFormacastFinishConditions", CheckFormacastFinishConditions);
eb.on("BoxForce10QuestionToFinish", Force10PointsToFinish);
eb.on("BoxSesstionExpired", SesstionExpired);
//#endregion

// async function onShopifyFollowOrder({num})
// {
//   let answer = ""
//     let tmp = num.split("#")[1]
//     let res = await apiRequest().get('command/shopify', {
//       params: {order_id: tmp}
//     })
//     if (res.data.answer === "not found")
//       answer = "It seems that the number entered doesn’t exist. Please verify and restart, or you can also contact us through the Live chat."
//     else if (res.data.answer === "not fulfilled yet")
//       answer = "Your order is being prepared."
//     else if (res.data.answer === "delivered")
//       answer = "Your order has already been delivered. If you didn’t receive it, here is the link to check directly with DHL : " + res.data.url
//     else if (res.data.answer === "ok")
//       answer = "To follow your order, here is the DHL link of your shipment : " + res.data.url

//   store_utils.emit_message({
//     message: { message : num},
//     sender: "self",
//     commit: true,
//     dialogflow: false,
//     slack: true,
//   })
//   store_utils.emit_message({
//     message: { message : answer},
//     sender: "bot",
//     commit: true,
//     dialogflow: false,
//     slack: true,
//   })
//   if (Object.keys(store.state.config.steps[store.state.user.style_profile_key].condition)[0]) {
//     styleProfile.generateNextStyleProfileStep(Object.keys(store.state.config.steps[store.state.user.style_profile_key].condition)[0])
//   }
//   else
//     store.state.user.style_profile_key = "start"
// }

async function onShopifyFollowOrder(order_id) {
  // customLogger("order_id == ", order_id.num)
  // customLogger("store_id : ", store.state.config.storeId)
  order_id = order_id.num;
  let answer = "";
  const road = "PrivateShopifyApp/getStatusOrder/" + order_id;
  // customLogger("road = ", road)
  let res = await apiRequest().get(road);
  // customLogger("res = ", store.state.config.i18n)
  if (res.data.order_status === "shipped")
    answer = store.state.config.i18n.fr.message.shipped_poste + res.data.url;
  else if (res.data.answer === "not fulfilled yet")
    answer = store.state.config.i18n.fr.message.preparation_in_progress;
  else if (res.data.answer === "delivered")
    answer =
      store.state.config.i18n.fr.message.order_already_delivery + res.data.url;
  else if (res.data.answer === "fulfilled")
    answer =
      store.state.config.i18n.fr.message.order_already_delivery + res.data.url;
  else if (res.data.answer === "Invalide order number")
    answer = store.state.config.i18n.fr.message.wrong_order_id;
  else answer = store.state.config.i18n.fr.message.wrong_order_id;

  // customLogger("answer = ", answer)
  store_utils.emit_message({
    message: { message: order_id },
    sender: "self",
    commit: true,
    dialogflow: false,
    slack: true,
  });
  store_utils.emit_message({
    message: { message: answer },
    sender: "bot",
    commit: true,
    dialogflow: false,
    slack: true,
  });
  if (
    Object.keys(
      store.state.config.steps[store.state.user.style_profile_key].condition
    )[0]
  ) {
    styleProfile.generateNextStyleProfileStep(
      Object.keys(
        store.state.config.steps[store.state.user.style_profile_key].condition
      )[0]
    );
  } else store.state.user.style_profile_key = "start";
}

async function onBoxUserInfo({ email, firstname }, url) {
  let response;
  let newMessage;
  let lang = store.state.user.lang;

  await store.dispatch("FETCH_USER_MESSAGES");
  if ((await utils.checkEmail(email)) === true) {
    try {
      store_utils.emit_message({
        message: {
          message: "Email : " + email + "\n\n" + "Firstname : " + firstname,
        },
        sender: "self",
        commit: true,
        dialogflow: false,
        slack: true,
        ignoreGpt: true,
        url,
      });
      newMessage =
        lang === "en"
          ? "Noted, thank you. An in store customer service representative will take care of your request as soon as possible."
          : "C'est noté merci. Un conseiller clientèle en boutique va prendre votre demande en charge dès que possible.";
      store_utils.emit_message({
        message: newMessage,
        sender: "bot",
        commit: true,
        dialogflow: false,
        slack: true,
      });
      store.state.navigation.mode = "chat";
    } catch (err) {
      customLogger(err);
    }
  } else {
    try {
      if (lang === "en")
        response =
          "It seems like the email address is not valid (extension unknown). Could you check your email address please?";
      else
        response =
          "Il semblerait que l'adresse email soit invalide (extension non reconnue). Pourriez-vous revérifier votre adresse email svp ?";
      store_utils.emit_message({
        message: response,
        sender: "bot",
        commit: true,
        dialogflow: false,
        slack: true,
        ignoreGpt: true,
      });
      store.state.user.style_profile_key = "have_question";
      store.state.user.data.condition = "productQuestion";

      setTimeout(() => {
        styleProfile.generateNextStyleProfileStep(
          store.state.user.data.condition
        );
      }, 1000);
    } catch (err) {
      customLogger(err);
    }
  }
}

async function onBoxEmailMessage({ email, textarea }, url) {
  const At = new Date();
  // customLogger("email", email)
  try {
    if (store.state.config.storeId == 59) //FORMACAST
    {
      store.state.user.loading_indicator = true;
      await utils.scrollDown()
      await onSendEmailBrand({ email, textarea });
      store.state.user.loading_indicator = false;
      styleProfile.generateNextStyleProfileStep("done");
      return
    } else {
    store_utils.emit_message({
      message: {
        message: "Message : " + textarea + "\n\n" + "Email : " + email,
        buttons: [{ name: "nomore.restart", value: "Retour à l'accueil" }],
        condition: { "Retour à l'accueil": "start" },
      },
      sender: "self",
      commit: true,
      dialogflow: false,
      slack: true,
      ignoreGpt: true, //if the message is from the box email
      url,
    });

    // conditions for store function email
    // NOTE : send email to brand only if the brand have the emailActivated to true in the config
      store.state.user.loading_indicator = true;
      await onSendEmailBrand({ email, textarea });
      store.state.user.loading_indicator = false

      store.commit("PUSH_MESSAGE", {
        sender_type: "bot",
        content: "chat.box_email.send_email.success",
        typing_indicator: true,
        sent_at: At.toISOString(),
      });
    
      store.commit("PUSH_MESSAGE", {
        sender_type: "bot",
        content: "chat.help_inact",
        typing_indicator: true,
        sent_at: At.toISOString(),
      });
    }
  } catch (err) {
    store.state.user.loading_indicator = false
    customLogger(err);
    store.commit("PUSH_MESSAGE", {
      sender_type: "bot",
      content: "chat.box_email.send_email.error",
      typing_indicator: true,
      sent_at: At.toISOString(),
    });
  }

  await apiRequest().post("message/update", {
    id: store.state.user.conversation_id.toString(),
    status: "To answer",
  });
}

async function onBoxEmail(email) {
  let response;
  let lang = store.state.user.lang;
  // customLogger("email", email)
  if (utils.CheckTld(email) === true) {
    try {
      store_utils.emit_message({
        message: {
          message: "Email : " + email,
          buttons: [{ name: "nomore.restart", value: "Retour à l'accueil" }],
          condition: { "Retour à l'accueil": "start" },
        },
        sender: "self",
        commit: true,
        dialogflow: false,
        slack: true,
      });
    } catch (err) {
      customLogger(err);
    }
  } else {
    try {
      if (lang === "en")
        response =
          "It seems like the email address is not valid (extension unknown). Could you check your email address please?";
      else
        response =
          "Il semblerait que l'adresse email soit invalide (extension non reconnue). Pourriez-vous revérifier votre adresse email svp ?";
      store_utils.emit_message({
        message: response,
        sender: "bot",
        commit: true,
        dialogflow: false,
        slack: true,
        ignoreGpt: true,
      });
    } catch (err) {
      customLogger(err);
    }
  }
}

function onBoxRestartStyleProfile() {
  if(store.state.config.storeId == 59) { //FORMACAST
    backToStepStarter() 
  }else{
    store.commit("SET_MODE", "style_profile");
    store.commit("RESET_QUIZ_OPTION");
    store.commit("SET_STYLE_PROFILE_KEY", null);
    store.state.user.data.to_save = { to_save: {} };
    // customLogger("LOL = ", store.user.data)
    delete store.state.user.data.last_step;
    store.dispatch("FETCH_STYLE_PROFILE_STEP");
  }

}

function onBoxRestartSizeReco() {
  store.commit("SET_MODE", "size_reco_profile");
  store.commit("RESET_QUIZ_OPTION");
  store.commit("SET_STYLE_PROFILE_KEY", null);
  store.state.user.data.to_save = { to_save: {} };
  delete store.state.user.data.last_step;
  store.dispatch("FETCH_STYLE_PROFILE_STEP");
}

function onAddToCart(product_url) {
  if (store.state.config.storeId == "25") {
    //FETE IMPERIALE
    store_utils.emit_message({
      message: i18n.get().tc("chat.add_cart").replace("PRODUCT", product_url),
      dialogflow: !store.state.navigation.interactions.hadPromo,
      commit: true,
      slack: true,
      sender: "self",
    });

    if (!store.state.navigation.interactions.hadPromo) {
      store.commit("ADD_INTERACTION", { key: "hadPromo", value: true });
    }
  }
  if (store.state.config.storeId == "50") {
    //FETE IMPERIALE
    store_utils.emit_message({
      message: i18n.get().tc("chat.confirm"),
      commit: true,
      slack: true,
      sender: "self",
    });
    store_utils.emit_message({
      message: i18n.get().tc("chat.add_cart"),
      commit: true,
      slack: true,
      sender: "bot",
      typing_indicator: true,
    });
  }
}

function checkShowPopup() {
  if (store.state.config.details.showPopUp == "scroll & wait") {
    // customLogger(store.state.session_navigation)
    if (
      !store.state.session_navigation.popupSeen &&
      store.state.session_navigation.pageScrolled &&
      store.state.session_navigation.waited10s
    ) {
      store.commit("OPEN_POPUP");
    }
  }
  if (
    !store.state.session_navigation.popupSeen &&
    store.state.session_navigation.waited10s
  ) {
    store.commit("OPEN_POPUP");
  }
}

function onScrollPage() {
  store.commit("SCROLLED_PAGE");
  store_utils.showBox();
  checkShowPopup();
}

async function onWaited10s() {
  store.commit("WAITED_10_S");
  checkShowPopup();
  /*
  if(store.state.config.storeId == "25") { //FETE IMPERIALE
    await store.dispatch('FETCH_PRODUCTS_ADDED_CART')
    products_added_cart = store.state.user.data.products_added_to_cart
    dates_products_added_cart = store.state.user.data.dates_products_added_to_cart
    three_month_ago = Date.now()
    three_month_ago.setMonth(three_month_ago.getMonth() -3)
    for(var i = 0; i < products_added_to_cart.length; i++) {
      date = new Date(dates_products_added_to_cart[i])
      if (three_month_ago > date) {
        //do things
      }
    }
  }
  */
}

/*
 * EVENTS:
 *  FETCH Store id
 *  FETCH User data
 *  FETCH Messages
 *  FETCH StyleProfile
 *  FETCH Config
 *
 *  Navigation:
 *  - Box Opened
 *  - Box Closed
 *  - Box Mode switched
 *  - Box Pop up Close
 *
 *  Interactions:
 *  - Button click
 *  - Form submit
 *  - Product liked
 *  - Product disliked
 *  - Product bookmarked
 *  - Product clicked
 *  - Product seen
 *
 *  Messages:
 *  - MessageSeen
 *  - SendMessage
 *  - ReceiveMessage
 *  - EditMessage
 *  - DeleteMessage
 *
 *  StyleProfile:
 *  - StepSeen
 *  - UniqueChoice
 *  - MultipleChoice
 *  - Input
 */

/*
 * FUNCTIONS
 */


async function onBoxAuthanticated() {
  //if the the store is a store with authentication
  if (store.state.config.details.store_with_authentication) {
    //if the user is not logged in
    if (!store.state.auth.token) {
      //show the auth flow
      store.commit("SHOW_AUTH_FLOW", true);
      return
    } else {
      store.commit("SHOW_AUTH_FLOW", false);
      //fetch the user data
      await store.dispatch("FETCH_USER_DATA", true);
      //check if the user has a subscription
      if (store.state.user.data?.subscription?.subscribe) {
        //fetch the user messages
        store.commit("SHOW_SUBS_FLOW", false);
        await store.dispatch("FETCH_USER_MESSAGES");
        onBoxMounted();
      }else{
        //if the user does not have a subscription
        //show the subs flow
        store.commit("SHOW_SUBS_FLOW", true);
      }
    }
  } else {
    //if the store is not a store with authentication
    //if the user is not logged in
    if (!store.state.auth.token) {
      //create a new user anonymous
      await store.dispatch("CREATE_NEW_USER_ANONYMOUS", {
        B_guid: utils.uuidv4(),
        S_guid: window.cleed_store_GUID,
      });
    }
    //fetch the user data
    await store.dispatch("FETCH_USER_DATA", true);
    //fetch the user messages
    await store.dispatch("FETCH_USER_MESSAGES");
    store.commit("SHOW_AUTH_FLOW", false);
    onBoxMounted();
  }
}

async function onBoxMounted(params) {
  if (utils.isMobile() && !params?.from?.SubscriptionForm) {
    store.commit("CLOSE_BOX");
  }

  await store.dispatch("FETCH_USER_DATA", true);
  await store.dispatch("FETCH_USER_MESSAGES");

  if (store.state.navigation.mode === "style_profile")
    store.dispatch("CURRENT_STYLE_PROFILE_STEP");

  // Set up matomo
  setUpMatomo(store.state.user.guid);

  ss.startSocket(process.env.VUE_APP_API_HOST, {
    query: {
      r_var: store.state.config.storeId,
      guid: store.state.user.guid,
      token: store.state.auth.token,
    },
  });


  if (store.state.config.storeId != 59 /*FORMACAST*/) { 
    active_job.init();
    active_job.create("waited10s", 10, function () {
      //eslint-disable-next-line
      customLogger("waited 10s");
      
      this.eb.emit("waited10s");
    });
  }

  if (store.state.config.details.showPopUp == "scroll & wait")
    store.commit("CLOSE_POPUP");

  // show the hided box when scroll down
  if (store.state.navigation.boxOpened == false && !utils.isMobile())
    utils.hide_box();
  else store.commit("SHOW_BOX");
  if (
    store.state.config.storeId === "46" &&
    window.location.href === "https://www.noo-paris.com/pages/guide-des-tailles"
  ) {
    store.state.user.style_profile_key = "start";
    store.commit("OPEN_BOX");
    styleProfile.generateNextStyleProfileStep("size_advice");
  }
  if (store.state.config.storeId === "20") {
    // size advice
    await sizeAdvice.manfieldSizeAdviceInit();
  }
  if (store.state.config.storeId === "33") {
    try{
      // size advice
      await sizeAdvice.lexSizeAdviceInit()

      // style profile
      const regex = /https:\/\/www\.lexception\.com\/[a-z]{2}-[a-z]{2}\/faq.*/;
      const url_to_match = window.location.href;
      const matches = url_to_match.match(regex);
      const commandNumber = GetCommandNumber();
      if (matches && matches.length > 0) {
        store.state.user.style_profile_key = "start";

        if (utils.isMobile()) {
          store.commit("CLOSE_BOX");
        } else {
          store.commit("OPEN_BOX");
        }
        store.commit("SET_MODE", "style_profile");
        styleProfile.generateNextStyleProfileStep("questions");

        if (commandNumber) {
          let listMessages = [
            { message: "popup.start", sender: "bot", step: "questions" },
            { message: "buttons.post_command", sender: "self", step: "" },
            { message: "message.order", sender: "bot", step: "command" },
            { message: "buttons.follow_return", sender: "self", step: "" },
            {
              message: "chat.return_order",
              sender: "bot",
              step: "return_follow",
            },
          ];

          listMessages.map((step, index) => {
            setTimeout(() => {
              store_utils.emit_message({
                message: step.message,
                commit: true,
                sender: step.sender,
                typing: false,
              });
            }, 100 * index);
          });
          setTimeout(() => {
            onGetReturnNumber({ num: commandNumber });
          }, 1000);
        }
    }
    }catch(e){
      customLogger("error: ", e)
    }

  }
  if (store.state.config.storeId === "46") {
    // ---------------------------------------------------------
    //  to comment
    // ---------------------------------------------------------
    if (
      process.env.NODE_ENV === "development" ||
      process.env.NODE_ENV === "staging"
    ) {
      var selectorNoo = document.querySelector("body");
      var buttonNoo = document.createElement("BUTTON");
      var btn = document.getElementById("product-addtocart-button");
      buttonNoo.innerHTML =
        store.state.user.lang === "fr"
          ? "Quelle est ma taille ?"
          : "What is my size?";
      buttonNoo.id = "cleed_size_reco";
      buttonNoo.style.padding = "10px";
      buttonNoo.style.border = "none";
      buttonNoo.style.fontSize = "16px";
      buttonNoo.style.cursor = "pointer";
      buttonNoo.style.backgroundImage =
        "linear-gradient(178deg, rgb(214, 205, 189), rgb(214, 205, 189) 10%,rgba(0,0,0,.07) 10%,rgba(0,0,0,.07) 100%), linear-gradient(178deg, rgb(214, 205, 189), rgb(214, 205, 189))";
      buttonNoo.style.minHeight = "50px";
      buttonNoo.style.padding = "5px 15px";
      buttonNoo.style.backgroundSize = "100% 200%,100% 100%";
      buttonNoo.style.backgroundPosition = "100% -100%,100% 100%";
      buttonNoo.style.backgroundRepeat = "no-repeat";
      buttonNoo.style.transition =
        "background-position .3s cubic-bezier(.215,.61,.355,1)";
      buttonNoo.style.transform = "translateZ(0)";
      buttonNoo.style.textAlign = "center";
      buttonNoo.style.borderRadius = "2px";
      btn.style = "display: none;";
      buttonNoo.style.display = "block";
      selectorNoo.appendChild(buttonNoo);
      let container = document.createElement("div");
      container.classList.add("custom-container");
      container.style.border = "1px solid black";
      container.style.padding = "10px";
      container.style.margin = "10px";
      let imgElement = document.createElement("img");
      imgElement.classList.add("image-zoom-noo");
      imgElement.src =
        "https://cdn.shopify.com/s/files/1/0100/4945/4137/products/body-hot-black-1_1100x.jpg?v=1678267972";
      imgElement.style.width = "100px";
      imgElement.style.height = "100px";
      container.appendChild(imgElement);
      let nameElement = document.createElement("h2");
      nameElement.classList.add("product-meta__title");
      nameElement.innerHTML = "Body Hot Black";
      container.appendChild(nameElement);
      let dummyPriceElement = document.createElement("p");
      dummyPriceElement.classList.add("price");
      dummyPriceElement.classList.add("price--large");
      dummyPriceElement.innerHTML = "";
      selectorNoo.appendChild(dummyPriceElement);
      let priceElement = document.createElement("p");
      priceElement.classList.add("price");
      priceElement.classList.add("price--large");
      let prefix = document.createTextNode("");
      let prefix2 = document.createTextNode("");
      let priceText = document.createTextNode("100 €");
      priceElement.appendChild(prefix);
      priceElement.appendChild(prefix2);
      priceElement.appendChild(priceText);
      container.appendChild(priceElement);
      selectorNoo.appendChild(container);

      // language
      var divElement = document.createElement("div");
      divElement.id = "weglot-switcher-1";
      selectorNoo.appendChild(divElement);
      var asideElement = document.createElement("aside");
      divElement.appendChild(asideElement);
      var innerDivElement = document.createElement("div");
      asideElement.appendChild(innerDivElement);
      innerDivElement.setAttribute("data-l", "en");
      customLogger("Current language:", innerDivElement.getAttribute("data-l"));
      var switchButton = document.createElement("button");
      switchButton.textContent = "Switch Language";
      switchButton.style.padding = "20px";
      switchButton.style.border = "none";
      switchButton.style.fontSize = "16px";
      switchButton.style.cursor = "pointer";
      switchButton.style.minHeight = "50px";
      switchButton.style.padding = "5px 15px";
      switchButton.style.textAlign = "center";
      switchButton.style.borderRadius = "2px";
      switchButton.style.backgroundColor = "rgb(0, 0, 0)";
      switchButton.style.color = "rgb(255, 255, 255)";
      switchButton.style.textTransform = "uppercase";
      selectorNoo.appendChild(switchButton);
      switchButton.addEventListener("click", function () {
        switchLanguage();
      });
      function switchLanguage() {
        var currentLanguage = innerDivElement.getAttribute("data-l");
        var newLanguage = currentLanguage === "en" ? "fr" : "en";
        innerDivElement.setAttribute("data-l", newLanguage);
        customLogger(
          "Language modal switched to:" +
          (newLanguage === "en" ? "English" : "French") +
          "."
        );
        alert(
          "Language modal switched to: " +
          (newLanguage === "en" ? "English" : "French") +
          "."
        );
      }
    }

    observeNooLang();
    // ---------------------------------------------------------
    // up to here
    // ---------------------------------------------------------

    (async () => {
      await initializeCleedSizeReco();
    })();
  }
}

function observeNooLang() {
  const attributeName = "data-l";
  const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === attributeName
      ) {
        const lang = mutation.target.getAttribute(attributeName);
        if (lang === "en" || lang === "fr") {
          customLogger(
            "Language changed to:",
            (lang === "en" ? "English" : "French") + "."
          );
          store.commit("SET_LANG", lang);
        }
      }
    }
  });

  const targetNode = document.querySelector("#weglot-switcher-1 aside div");

  if (!targetNode) {
    customLogger("targetNode Lang not found");
    return;
  }

  const config = { attributes: true, attributeFilter: [attributeName] };

  observer.observe(targetNode, config);
}

function GuideTailleV3() {
  store.state.user.modal_reco_sizeModal = true;
}

//#region Size advice functions

const initializeCleedSizeReco = async () => {
  const cleed_size_reco = document.getElementById("cleed_size_reco");
  const style =
    "font-weight: bold; padding: 4px 8px; border-radius: 4px;color: white;";

  if (cleed_size_reco) {
    // remove href attribute
    cleed_size_reco.removeAttribute("href");
    //  add cursor pointer
    cleed_size_reco.style.cursor = "pointer";
    customLogger("%cCleed size reco", `${style}background-color: blue`);
    var currentUrl = window.location.href;
    var urlObj = new URL(currentUrl);
    urlObj.search = "";
    urlObj.hash = "";
    var urlNoo = urlObj.toString();
    let isProductFound = false;

    try {
      const product = await store.dispatch("FETCH_NOO_VERIFY_PRODUCT", {
        url: urlNoo,
      });

      if (!product?.data?.index_modale) {
        throw new Error("Product not found");
      }

      customLogger("%cProduct found", `${style}background-color: green`);
      isProductFound = true;
    } catch (e) {
      customLogger("%cProduct not found", `${style}background-color: red`);
    }

    cleed_size_reco.onclick = () => {
      customLogger("%cButton clicked", `${style}background-color: blue`);
      if (isProductFound) {
        GuideTailleV3();
      } else {
        const url = "https://www.noo-paris.com/pages/guide-des-tailles";
        window.open(url, "_blank");
      }
    };
  } else {
    customLogger("%cButton not found", `${style}background-color: red`);
  }
};


//#endregion

function GetCommandNumber() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const commandNumber = urlParams.get("retour");
  return commandNumber;
}

function onBoxClose() {
  //matomo.track
  if (window.matomoTracker) matomoTracker.trackEvent("Chat", "Close");
  store.commit("CLOSE_BOX");
}

function onBoxOpen() {
  //matomo.track
  if (specs._NO_CHAT) {
    // customLogger('set style profile')
    store.commit("SET_MODE", "style_profile");
    store.commit("STYLE_PROFILE_RESUME");
    store.dispatch("CURRENT_STYLE_PROFILE_STEP");
  }
  if (window.matomoTracker) matomoTracker.trackEvent("Chat", "Open");
  if (store.state.config.storeId == 25)
    store.commit("SET_MODE", "style_profile");
  store.dispatch("OPEN_BOX");
}

function onBoxToggle() {
  if (store.state.navigation.boxOpened) eb.emit("BoxClose");
  else eb.emit("BoxOpen");
}

async function onBoxSwitchMode({ text, mode }) {
  const At = new Date();
  store.commit("SET_MODE", mode);

  if (
    store.state.user.style_profile_resume == false &&
    mode === "style_profile"
  ) {
    styleProfile.generateNextStyleProfileStep();
    store.state.user.style_profile_resume = true;
  } else if (
    store.state.user.style_profile_resume &&
    mode === "style_profile"
  ) {
    store.commit("STYLE_PROFILE_RESUME");
    store.dispatch("CURRENT_STYLE_PROFILE_STEP");
  } else if (mode === "chat") {
    let push_message = true;
    const messages_length = store.state.user.messages.length;

    if (store.state.user.style_profile) {
      store.commit("DISABLE_STYLE_PROFILE");
      store.commit("STYLE_PROFILE_RESUME");
    }
    let help_message = "chat.help_inact";
    if (store.state.config.chat_config.chat_state.state == "active") {
      help_message = "chat.help";
    } else if (
      store.state.config.chat_config.chat_state.state == "not_reactive"
    ) {
      help_message = "chat.help_notreact";
    }
    if (
      store.state.config.storeId != 49 &&
      messages_length > 0 &&
      store.state.user.messages[messages_length - 1].content == help_message
    ) {
      push_message = false;
    }
    if (text) {
      store_utils.emit_message({
        message: text,
        dialogflow: true,
        commit: true,
        sender: "self",
      });
    }
    if (push_message) {
      store.commit("PUSH_MESSAGE", {
        sender_type: "bot",
        content: help_message,
        typing_indicator: !text,
        sent_at: At.toISOString(),
      });
    }
  }
  if (store.state.config.storeId == 49) {
    if (mode === "info_mode") {
      if (text) {
        store_utils.emit_message({
          message: text,
          commit: true,
          sender: "self",
        });
      }
      store.state.user.style_profile_key = "start";
      styleProfile.generateNextStyleProfileStep("begin");
    } else if (mode === "whatsapp_mode") {
      if (text) {
        store_utils.emit_message({
          message: text,
          dialogflow: true,
          commit: true,
          sender: "self",
        });
      }
      if (store.state.user.phone) {
        store_utils.emit_message({
          message: "whatsapp_messaging.init_store_conversation",
          dialogflow: true,
          commit: true,
          sender: "bot",
          typing: true,
        });
      } else {
        store_utils.emit_message({
          message: "whatsapp_messaging.add_phone",
          dialogflow: true,
          commit: true,
          sender: "bot",
        });
      }
    } else if (mode === "your_mode") {
      if (text) {
        store_utils.emit_message({
          message: text,
          commit: true,
          sender: "self",
        });
      }
      store.state.user.style_profile_key = "start";
      styleProfile.generateNextStyleProfileStep("recommendation");
    } else if (mode === "rewards_mode") {
      if (text) {
        store_utils.emit_message({
          message: text,
          commit: true,
          sender: "self",
        });
      }
      store.commit("PUSH_MESSAGE", {
        sender_type: "bot",
        content: "text.dev_mode",
        typing_indicator: !text,
        sent_at: At.toISOString(),
      });
    } else if (mode === "live_shop_mode") {
      if (text) {
        store_utils.emit_message({
          message: text,
          commit: true,
          sender: "self",
        });
      }
      store.state.user.style_profile_key = "start";
      styleProfile.generateNextStyleProfileStep("steps_chanel");
    } else if (mode === "product_s_mode") {
      if (text) {
        store_utils.emit_message({
          message: text,
          commit: true,
          sender: "self",
        });
      }
      store.commit("PUSH_MESSAGE", {
        sender_type: "bot",
        content: "text.dev_mode",
        typing_indicator: !text,
        sent_at: At.toISOString(),
      });
    } else if (mode === "search") {
      store.commit("SET_MODE", "search");
    } else if (mode === "visual_s_mode") {
      if (text) {
        store_utils.emit_message({
          message: text,
          commit: true,
          sender: "self",
        });
      }
      store.commit("PUSH_MESSAGE", {
        sender_type: "bot",
        content: "text.dev_mode",
        typing_indicator: !text,
        sent_at: At.toISOString(),
      });
    } else if (mode === "size_mode") {
      if (text) {
        store_utils.emit_message({
          message: text,
          commit: true,
          sender: "self",
        });
      }
      store.state.user.style_profile_key = "start";
      styleProfile.generateNextStyleProfileStep("size_advice");
    }
  }
}

function onChatSubmitMessage(message, url) {
  const At = new Date();
  customLogger("Message send: ", message);
  let send_dialogflow = false;
  let openai = false;
  let response_dialogflow =
    store.state.user.lang == "en"
      ? "If the answer is not sufficient, please specify it and a human agent will takeover shortly to answer you directly here (or by email if you specified it):"
      : "Si la réponse n'est pas suffisante, merci de le préciser et un agent humain prendra la main rapidement pour vous répondre directement ici (ou par email si vous l'avez précisé)";

  // customLogger("url = ", url)
  if (window.matomoTracker) matomoTracker.trackEvent("box", "Message", message);
  if (store.state.config.details.dialogflow_try_nbr > 0) {
    store.state.config.details.dialogflow_try_nbr -= 1;
    send_dialogflow = true;
  }
  /**
   * the openia will be true only on the store ids
   * the max answers from openai in max_openai_reply
   * the first 100 question answerd by open ai
   */
  var max_openai_reply = store.state.config.openai_question_counter;
  if (
    store.state.config.chatgpt &&
    store.state.user.questionCounter <= max_openai_reply
    ) {
      store.state.user.questionCounter++;
      // FIXME: dialogflow not work on store 49
      send_dialogflow = false;
      store.state.user.loading_indicator = true;
  }
  store_utils.emit_message({
    message,
    slack: true,
    dialogflow: false,
    commit: true,
    questionCounter: store.state.user.questionCounter,
    should_send_dialogflow: send_dialogflow,
    url,
  });
  if (store.state.config.details.ask_email == "on message") {
    const send = {
      sender_type: "bot",
      content: {},
      typing_indicator: true,
      sent_at: At.toISOString(),
    };
    send.content.message = "text.email";
    send.content.form = get_ask_mail_form();
    store.commit("PUSH_MESSAGE", send);
  }
}

function onChatTrackingTyping(data) {
  ss.socket.emit("ChatTrackingTyping", data);
}

function onChatReceiveMessage(data) {
  // customLogger("onChatReceiveMessage", data);
  const At = new Date();
  //customLogger(data);
  let response_dialogflow =
    store.state.user.lang == "en"
      ? "If the answer is not sufficient, please specify it and a human agent will takeover shortly to answer you directly here (or by email if you specified it):"
      : "Si la réponse n'est pas suffisante, merci de le préciser et un agent humain prendra la main rapidement pour vous répondre directement ici (ou par email si vous l'avez précisé)";

  let rating_msg =
    store.state.user.lang === "en"
      ? "What did you think of this assistance?"
      : "Qu'avez-vous pensé de cette assistance ?";

  if (data?.content?.type && data.content.type === "rating") {
    data.message = rating_msg;
  }

  if (
    // the list of stores that have chat gpt and should not use loading_indicator 3 dots
    store.state.config.chatgpt &&
    store.state.user.loading_indicator
    ) {
      store.state.user.loading_indicator = false;
  }
    
  //and  hold the input till recieve the last the answer from openai
  if (data?.typing_indicator){
    store.state.user.loading_indicator = true;
  }

  if (data.type === "input.welcome") {
    store.state.config.details.dialogflow_try_nbr += 1;
  } else if (data.oneTryMode === true) {
    setTimeout(function () {
      store_utils.emit_message({
        message: response_dialogflow,
        slack: true,
        dialogflow: false,
        commit: true,
        sender: "bot",
        url: window.location.href,
      });
      customLogger("onChatReceiveMessage --- 5000s");
    }, 5000);
  }
  const now = Date.now();
  let send = {
    sender_type: data.sender_type || "bot",
    content: {},
    typing_indicator: true,
    timestamp_client: now,
    from_slack: data.from_slack || false,
    sent_at: At.toISOString(),
  };
  // customLogger('RECEIVE MESSAGE SEND', send)
  if (window.matomoTracker) matomoTracker.trackEvent("Chat", "New Step");

  if (data.action == "ask_gender") {
    send.content.message = data.message;
    send.content.buttons = get_ask_gender();
    send.typing_indicator = false;
    if (data.payload) {
      send.content.on_click =
        "(v)=>{ customLogger('GENDER CHOSEN', v); this.$eb.emit('ChatSearch', { 'payload':'" +
        JSON.stringify(data.payload) +
        "', 'guid':'" +
        store.state.user.guid +
        "', 'id': '" +
        ss.socket.id +
        "', 'store_id': " +
        store.state.config.storeId +
        ", 'lang': '" +
        store.state.user.lang +
        "', 'gender': v })}";
    }
    send.id = data.id;
  } else if (data.action == "ask_email") {
    send.content.message = data.message;
    send.content.form = get_ask_mail_form();
    send.id = data.id;
  } else if (data.action == "ask_email_and_message") {
    send.content.message = data.message;
    send.content.form = {
      textarea: {
        placeholder: "chat.write_message_here",
      },
      inputs: [
        {
          name: "Email",
          value: "email",
          type: "email",
          required: "true",
        },
        {
          name: "signup.confidentiality",
          href: specs.TERMS_URL,
          value: "confidentiality",
          type: "checkbox",
          required: "true",
          class: "chat-small",
        },
      ],
      submit_text: "ok",
      on_click: "ChatMessageEmailInput",
    };
    send.id = data.id;
  } else if (data.sender_type && data.sender_type === "admin") {
    send.content = data;
    send.id = data.id;
  } else if (data && data.message) {
    send.content = data;
    send.id = data.id;
  }

  if (!data.action == "ask_email" && !data.action == "ask_gender") {
    active_job.create(
      "question_answered",
      25,
      function () {
        // this is the context set by call | context store injected
        if (
          this[0] ==
          this.store.state.user.messages[
            this.store.state.user.messages.length - 1
          ].timestamp_client ||
          (this.store.state.user.messages[
            this.store.state.user.messages.length - 1
          ] &&
            this.store.state.user.messages[
              this.store.state.user.messages.length - 1
            ].content &&
            this.store.state.user.messages[
              this.store.state.user.messages.length - 1
            ].content.message &&
            this[1] ==
            this.store.state.user.messages[
              this.store.state.user.messages.length - 1
            ].content.message)
        ) {
          // send question
          const send = {
            sender_type: "bot",
            content: {
              message: "Have I answered your question ?",
              buttons: [
                { name: "yes", value: "dont_ask_email_from_question_answered" },
                { name: "no", value: "ask_email_from_question_answered" },
              ],
            },
            typing_indicator: false,
            sent_at: At.toISOString(),
          };

          this.store.commit("PUSH_MESSAGE", send);
        }
      },
      now,
      data.message
    );
    // customLogger('5controler ->', data);
  }

  if (data?.ignore_typing_indicator) {
    send.typing_indicator = false;
  }

  // updateting and printing new messages
  store.commit("PUSH_MESSAGE", send);

  /***** lahcen ****tracking the input*********/
  ss.socket.emit("ChatTrackingTyping", { showing: false });
  /******************/

  if (store.state.navigation.boxOpened === false) {
    store.commit("PUSH_NOTIFICATION");
  }
  /*
 if (data.action == 'open.url' && data.fulfillmentMessages[1] && data.fulfillmentMessages[1].payload) {
    setTimeout(() => {
      var url = data.fulfillmentMessages[1].payload.url
      if (window.location.hostname && url.includes(window.location.hostname))
        window.location.href = url;
      else
        window.open(url, '_blank');
    }, 3000);
  }
  */

  //#region notification sound
  if (
    !store.state.navigation.boxOpened &&
    store.state.navigation.notificationSound
  ) {
    audio.volume = 0.1;
    audio.play();
  }

  //#endregion
  if(data.message == "chat.payment_failed"){
    store.dispatch("SET_MODAL",{
      active: true,
      title: "Un problème est survenu",
      body: "chat.payment_failed",
      type: "error",
    }).then(() => {
      store.commit("SHOW_SUBS_FLOW", true)
    })
  }
}

async function onCreateTicketZendesk({ email, textarea }) {
  const At = new Date();
  var currentUrl = window.location.href;
  // customLogger("CURRENT URL : ", currentUrl)
  if (
    store.state.config.storeId == "41" ||
    store.state.config.storeId == "33"
  ) {
    let lang = store.state.user.lang;
    let response = "";
    let zendesk_type = store.state.user.data.order;
    let subject = i18n.get().tc("zendesk.customer");
    if (zendesk_type === "annulation")
      subject = i18n.get().tc("zendesk.cancellation");
    else if (zendesk_type === "modification")
      subject = i18n.get().tc("zendesk.modification");
    else if (zendesk_type === "defective_article")
      subject = i18n.get().tc("zendesk.defective");

    let payload = {
      ticket: {
        comment: {
          body:
            textarea +
            "\n\n" +
            "Email  :" +
            email +
            "\n\n" +
            "URL : " +
            currentUrl,
        },
        priority: "urgent",
        subject: subject,
        requester: { name: email, email: email },
      },
    };
    let help_message = "chat.help_inact";
    if (store.state.config.chat_config.chat_state.state == "active") {
      help_message = "chat.help";
    } else if (
      store.state.config.chat_config.chat_state.state == "not_reactive"
    ) {
      help_message = "chat.help_notreact";
    }
    if (utils.CheckTld(email) === true) {
      try {
        const lexMessageString = {
          "fr" : "Votre message a bien été envoyé à notre service client. Notre équipe vous répondra au plus vite.",
          "en": "Your message has been sent to our customer service department. Our team will get back to you as soon as possible."
        }
        const messageString = {
          "fr": "Très bien, nous vous recontacterons au plus vite.",
          "en": "Thanks. We'll come back to you as soon as possible."
        }
        lang = store.state.user.lang; 
        if( store.state.config.storeId != 33){
          store_utils.emit_message({
            message: messageString[lang],
            sender: "self",
            commit: true,
            dialogflow: store.state.navigation.mode != "style_profile",
            slack: true,
            ignoreGpt: true,
          });
        }

        store_utils.emit_message({
          message:
            (store.state.config.store_id == 41)  ? messageString['en'] 
            : store.state.config.storeId == 33 ? lexMessageString[lang] 
            : messageString[lang],
          sender: "bot",
          commit: true,
          dialogflow: store.state.navigation.mode != "style_profile",
          slack: true,
          ignoreGpt: true,
        });

        let res = (await store.dispatch("CREATE_TICKET", payload)).data;
      } catch (err) {
        customLogger(err);
      }
    } else {
      try {
        if (lang === "en")
          response =
            "It seems like the email address is not valid (extension unknown). Could you check your email address please?";
        else
          response =
            "Il semblerait que l'adresse email soit invalide (extension non reconnue). Pourriez-vous revérifier votre adresse email svp ?";
        store_utils.emit_message({
          message: response,
          sender: "bot",
          commit: true,
          dialogflow: false,
          slack: true,
          ignoreGpt: true,
        });
        store.commit("PUSH_MESSAGE", {
          sender_type: "bot",
          content: help_message, // chat.enter ?
          typing_indicator: !text,
          sent_at: At.toISOString(),
        });
      } catch (err) {
        customLogger(err);
      }
    }
  }
}
async function onGetReturnNumber({ num }) {
  if (store.state.config.storeId == "33") {
    var final_message = "";
    var value_api = {};
    let return_id = num;
    let answer = "Numéro inconnu";
    const lang = store.state.user.lang;
    const road = "grid/return_tracking/" + num;
    let res = {};
    try {
      res = await apiRequest().get(road);
      value_api = res.data.return_data;
    } catch (err) {
      res = { data: { return_data: {} } };
      value_api = "badInput";
    }
    if (lang == "fr") {
      let date_retour = "";
      if (res.data.return_data.return_date) {
        let sp = res.data.return_data.return_date.split("-");
        let year = sp[0];
        let month = sp[1];
        let day = sp[2];
        date_retour = day + "-" + month + "-" + year;
        customLogger("date_retour = ", date_retour);
      }
      // if (res.data.return_data.reception_date) {
      //   let sp = res.data.return_data.reception_date.split('-');
      //   let year = sp[0]
      //   let month = sp[1]
      //   let day = sp[2]
      //   reception_date = day + '-' + month + '-' + year
      //   customLogger("reception_date = ", reception_date)
      // }
      customLogger("date_retour42 = ", date_retour);
      if (res.data.return_data.return_status == "remboursement OK") {
        // if (res.data.return_data.return_date && res.data.return_data.reception_date)
        //   final_message += "Votre retour demandé le " + date_retour + " a bien été reçu à notre entrepôt le " + reception_date
        final_message +=
          "\n\nVotre remboursement a bien été effectué sur le moyen de paiement d’origine.";
      }
      if (res.data.return_data.return_status == "en attente de reception") {
        if (res.data.return_data.return_date)
          final_message +=
            "Nous sommes en attente de réception de votre retour demandé le " +
            date_retour;
        if (
          res.data.return_data.return_id != "nope" &&
          res.data.return_data.link_follow != "nope"
        )
          final_message +=
            "\n\nVous pouvez suivre votre colis numéro " +
            res.data.return_data.return_id +
            ' en cliquant sur ce lien : <a href="' +
            res.data.return_data.link_follow +
            '" target="_blank">' +
            res.data.return_data.link_follow +
            "</a>";
        final_message +=
          "\n\nAprès la livraison du colis, un délais minimum de 2 jours ouvrés est nécessaire pour le traitement du colis par notre équipe.";
      }
      if (res.data.return_data.return_status == "en attente de remboursement") {
        if (res.data.return_data.return_date)
          final_message +=
            "Votre retour a bien été traité à notre entrepôt le " +
            date_retour +
            ".\n";
        final_message +=
          " Votre remboursement sera effectué dans un délais maximum de 2 jours ouvrés.";
      }
      if (value_api == "badInput")
        final_message =
          "Nous sommes désolés, nous n'avons pas trouvé de retour avec ces informations.\nNous vous invitons à contacter notre service client pour plus d'information.";
    } else {
      if (res.data.return_data.return_status == "remboursement OK") {
        // if (res.data.return_data.return_date && res.data.return_data.reception_date)
        //   final_message += "The return you requested on " + res.data.return_data.return_date + " was received at our warehouse on " + res.data.return_data.reception_date
        final_message +=
          "\n\nYour refund has been made on the original payment method.";
      }
      if (res.data.return_data.return_status == "en attente de reception") {
        if (res.data.return_data.return_date)
          final_message +=
            "We are waiting to receive your requested return on " +
            res.data.return_data.return_date;
        if (
          res.data.return_data.return_id != "nope" &&
          res.data.return_data.link_follow != "nope"
        )
          final_message +=
            "\n\nYou can track your package number " +
            res.data.return_data.return_id +
            ' by clicking on this link: <a href="' +
            res.data.return_data.link_follow +
            '" target="_blank">' +
            res.data.return_data.link_follow +
            "</a>";
        final_message +=
          "\n\nAfter delivery of the package, a minimum of 2 working days is necessary for the treatment of the package by our team.";
      }
      if (res.data.return_data.return_status == "en attente de remboursement") {
        if (res.data.return_data.return_date)
          final_message +=
            "Your return was processed at our warehouse on " +
            res.data.return_data.return_date +
            ".\n";
        final_message +=
          " Your refund will be made within a maximum of 2 working days.";
      }
      if (value_api == "badInput")
        final_message =
          "We are sorry, we could not find a return with this information. We invite you to contact our customer service for more information.";
    }
    customLogger(final_message);
    store_utils.emit_message({
      message: { message: num },
      sender: "self",
      commit: true,
      dialogflow: false,
      slack: true,
    });
    store_utils.emit_message({
      message: { message: final_message },
      sender: "bot",
      commit: true,
      dialogflow: false,
      slack: true,
    });
    store.state.user.style_profile_key = "return_follow";
    if (
      Object.keys(
        store.state.config.steps[store.state.user.style_profile_key].condition
      )[0]
    ) {
      styleProfile.generateNextStyleProfileStep(
        Object.keys(
          store.state.config.steps[store.state.user.style_profile_key].condition
        )[0]
      );
    } else {
      store.state.user.style_profile_key = "start";
    }

    // if (res.data.return_status.link_follow)
    //   link_follow = res.data.return_status.link_follow
    // else
    //   customLogger("1")
    // if (res.data.return_status.number != NaN)
    //   number = res.data.return_status.number
    // else
    //   customLogger("2")
    //   // number = "Not found"
    // if (res.data.return_status.return_date != NaN)
    //   return_date = res.data.return_status.return_date
    // else
    //   customLogger("3")
    //   // return_date = "Not found"
    // if (res.data.return_status.reception_date != NaN)
    //   reception_date = res.data.return_status.reception_date
    // else
    //   customLogger("4")
    //   // reception_date = "Not found"
    // customLogger(link_follow, number, return_date, reception_date)
    // // if (res.data.return_status === "")
    //   if (lang == "fr")
    //     answer = store.state.config.i18n.fr.return_status.;
    //   else
    //     answer = store.state.config.i18n.en.return_status.;
    // else if (res.data.return_status === "")
    // if (lang == "fr")
    //   answer = store.state.config.i18n.fr.return_status.;
    // else
    //   answer = store.state.config.i18n.en.return_status.;
    // else if (res.data.return_status === "")
    // if (lang == "fr")
    //   answer = store.state.config.i18n.fr.return_status.;
    // else
    //   answer = store.state.config.i18n.en.return_status.;
  }
}

// STEPS
//   "order_follow": {
//     "message": "intent.Follow my order",
//     "buttons": [
//       {
//         "name": "nomore.restart",
//         "value": "Retour à l'accueil"
//       }
//     ],
//     "condition": {
//       "start_after_follow_order": "start_after_follow_order",
//       "Retour à l'accueil": "start"
//     },
//     "form": {
//       "inputs": [
//         {
//           "name": "command.input_number",
//           "value": "num",
//           "type": "text",
//           "required": "true"
//         }
//       ],
//       "submit_text": "ok",
//       "on_click": "GetCommandNumber"
//     }
// },

async function onGetCommandNumber({ num }) {
  if (store.state.config.storeId == "50") {
    let order_id = num;
    let answer = "Numéro inconnu";
    const lang = store.state.user.lang;
    const road = "magento/getStatusOrder/" + order_id;
    let res = await apiRequest().get(road);
    if (res.data.order_status === "processing")
      if (lang == "fr")
        answer = store.state.config.i18n.fr.order_status.processing;
      else answer = store.state.config.i18n.en.order_status.processing;
    if (res.data.order_status === "payment_review")
      if (lang == "fr")
        answer = store.state.config.i18n.fr.order_status.payment_review;
      else answer = store.state.config.i18n.en.order_status.payment_review;
    if (res.data.order_status === "return_complete")
      if (lang == "fr")
        answer = store.state.config.i18n.fr.order_status.return_complete;
      else answer = store.state.config.i18n.en.order_status.return_complete;
    if (res.data.order_status === "canceled")
      if (lang == "fr")
        answer = store.state.config.i18n.fr.order_status.canceled;
      else answer = store.state.config.i18n.en.order_status.canceled;
    if (res.data.order_status === "pending")
      if (lang == "fr")
        answer = store.state.config.i18n.fr.order_status.pending;
      else answer = store.state.config.i18n.en.order_status.pending;
    if (res.data.order_status === "complete")
      if (lang == "fr")
        answer = store.state.config.i18n.fr.order_status.complete;
      else answer = store.state.config.i18n.en.order_status.complete;
    if (res.data.order_status === "closed")
      if (lang == "fr") answer = store.state.config.i18n.fr.order_status.closed;
      else answer = store.state.config.i18n.en.order_status.closed;
    if (res.data.order_status === "Invalide order number")
      if (lang == "fr")
        answer = store.state.config.i18n.fr.order_status.invalid;
      else answer = store.state.config.i18n.en.order_status.invalid;
    store_utils.emit_message({
      message: { message: order_id },
      sender: "self",
      commit: true,
      dialogflow: false,
      slack: true,
    });
    store_utils.emit_message({
      message: { message: answer },
      sender: "bot",
      commit: true,
      dialogflow: false,
      slack: true,
    });
    store.state.user.style_profile_key = "order_follow";
    if (
      Object.keys(
        store.state.config.steps[store.state.user.style_profile_key].condition
      )[0]
    ) {
      styleProfile.generateNextStyleProfileStep(
        Object.keys(
          store.state.config.steps[store.state.user.style_profile_key].condition
        )[0]
      );
    } else {
      store.state.user.style_profile_key = "start";
    }
  }
  if (store.state.config.storeId == "38") {
    let message_to_send =
      store.state.user.lang == "en"
        ? "We will get back to you as soon as possible"
        : "C'est noté, nous allons revenir vers vous dès que possible";
    store_utils.emit_message({
      message: { message: num },
      sender: "bot",
      commit: true,
      dialogflow: false,
      slack: true,
    });
    store_utils.emit_message({
      message: { message: message_to_send },
      sender: "bot",
      commit: true,
      dialogflow: false,
      slack: true,
    });
    return;
  }
  if (
    store.state.config.storeId == "37" ||
    store.state.config.storeId == "33"
  ) {
    let payload = {
      email: num.includes("@") ? num : null, // TODO: better function to determine the input
      command_id: num.includes("-") ? num : null,
      command_follow_id: num,
    };

    store_utils.emit_message({
      message: { message: num },
      sender: "bot",
      commit: true,
      dialogflow: false,
      slack: true,
    });
    let content = {};

    let date;
    let lang = store.state.user.lang;
    let message = "command.unknown";
    content.message = message;

    try {
      let res;
      res = (await store.dispatch("GET_COMMAND", payload)).data.command;
      if (res.command_expedition_date)
        date = utils.convert_date_format(
          res.command_expedition_date.split("T")[0],
          lang
        );

      // customLogger('response', res)

      if (
        res.command_follow_url == "en preparation" &&
        res.transporter == "Retrait boutique"
      ) {
        message = i18n
          .get()
          .tc("command.being_prepared")
          .replace("COMMAND_ID", res.command_id);
      } else if (
        res.transporter == "Retrait boutique" &&
        res.command_follow_url == "commande prete"
      ) {
        message = i18n
          .get()
          .tc("command.store_pickup")
          .replace("COMMAND_ID", res.command_id)
          .replace("EXPEDITION_DATE", date);
      } else if (
        res.command_follow_url == "en preparation" ||
        !res.command_expedition_date
      ) {
        message = i18n
          .get()
          .tc("command.in_preparation")
          .replace("COMMAND_ID", res.command_id);
      } else if (!res.command_follow_url) {
        message = i18n
          .get()
          .tc("command.no_follow_url")
          .replace("EXPEDITION_DATE", date)
          .replace("FOLLOW_ID", res.command_follow_id)
          .replace("COMMAND_ID", res.command_id)
          .replace("TRANSPORTER", res.transporter);
      } else if (!res.command_follow_url && !res.command_follow_id) {
        message = i18n
          .get()
          .tc("command.no_follow_url_id")
          .replace("EXPEDITION_DATE", date)
          .replace("COMMAND_ID", res.command_id)
          .replace("TRANSPORTER", res.transporter);
      } else {
        message = i18n
          .get()
          .tc("command.sent")
          .replace("EXPEDITION_DATE", date)
          .replace("FOLLOW_URL", res.command_follow_url)
          .replace("FOLLOW_ID", res.command_follow_id)
          .replace("COMMAND_ID", res.command_id)
          .replace("TRANSPORTER", res.transporter);
      }
      content.message = message;
    } catch (err) {
      customLogger(err);
    }
    store.state.user.style_profile_key = "order_follow";
    store_utils.emit_message({
      message: {
        message: message,
        buttons: [{ name: "nomore.restart", value: "Retour à l'accueil" }],
        condition: { "Retour à l'accueil": "start" },
      },
      sender: "bot",
      commit: true,
      dialogflow: false,
      slack: true,
    });
  }
}

function onChatEmailInput({ email }) {
  ss.socket.emit("rename", {
    id: ss.socket.id,
    name: "0-" + email.replace(".", "_").replace("@", "_at_"),
    store_id: store.state.config.storeId,
    email: email,
  });

  store_utils.emit_message({
    message: "Email : " + email,
    sender: "self",
    commit: false,
    dialogflow: store.state.navigation.mode != "style_profile",
    slack: true,
  });

  store.dispatch("SAVE_EMAIL", email);
}

function onChatMessageEmailInput({ email, textarea }) {
  if (store.state.config.details.Email.Activate == true) {
    onSendEmailBrand({ email, text: textarea });
  }
  ss.socket.emit("rename", {
    id: ss.socket.id,
    name: "0-" + email.replace(".", "_").replace("@", "_at_"),
    store_id: store.state.config.storeId,
  });

  store_utils.emit_message({
    message: "Email : " + email,
    sender: "self",
    commit: false,
    dialogflow: store.state.navigation.mode != "style_profile",
    slack: true,
  });

  store_utils.emit_message({
    message: textarea,
    sender: "self",
    commit: false,
    dialogflow: store.state.navigation.mode != "style_profile",
    slack: true,
  });

  store_utils.emit_message({
    message: i18n.get().tc("chat.email"),
    sender: "bot",
    commit: true,
    dialogflow: store.state.navigation.mode != "style_profile",
    slack: true,
  });

  store.dispatch("SAVE_EMAIL", email);
}

async function onSendEmailBrand({ email, textarea }) {
  try {
  ss.socket.emit("rename", {
    id: ss.socket.id,
    name: "0-" + email.replace(".", "_").replace("@", "_at_"),
    store_id: store.state.config.storeId,
  });
    await store.dispatch("SEND_EMAIL_BRAND", { email, textarea });
  } catch (err) {
    customLogger("onSendEmailBrand error", err?.response?.data);
    throw err;
  }
}

function onDislikeModeButtonClick(button, tmp_content) {
  // deleting button because we don't want save it
  const At = new Date();
  delete store.state.user.messages[store.state.user.messages.length - 1].content
    .button;
  store_utils.emit_message({
    message:
      store.state.user.messages[store.state.user.messages.length - 1].content,
    sender: "bot",
    ignoreGpt: true,
    logger: "onDislikeModeButtonClick 1",
    cb: async () => {
      await apiRequest().patch("interactions/dislike", {
        action: "add",
        product_id: tmp_content.product_id,
        reasons: [button.text_without_t],
        ignoreGpt: true,
      });

      // save message
      store_utils.emit_message({
        message: button.text,
        commit: true,
        sender: "self",
        ignoreGpt: true,
        logger: "onDislikeModeButtonClick 2",
        cb: () =>
          store.commit("PUSH_MESSAGE", {
            sender_type: "bot",
            content: "Ok",
            typing_indicator: false,
            sent_at: At.toISOString(),
          }),
      });

      // disable
      store.commit("DISLIKE_MODE", false);

      // rm tmp content
      store.commit("DELETE_TMP_CONTENT");

      if (store.state.user.style_profile)
        setTimeout(function () {
          styleProfile.force_next_step();
        }, 300);
    },
  });
}
function onBoxButtonClick({ text, value }) {
  const At = new Date();
  let help_message = "chat.help_inact";
  if (store.state.config.chat_config.chat_state.state == "active") {
    help_message = "chat.help";
  } else if (
    store.state.config.chat_config.chat_state.state == "not_reactive"
  ) {
    help_message = "chat.help_notreact";
  }

  if (store.state.config.storeId == 35 && value == "start") {
    store.state.user.style_profile_key = "start";
    store.state.user.data.condition = "size_reco";
    store.commit("SET_MODE", "style_profile");
    styleProfile.generateNextStyleProfileStep("size_reco");
    return;
  }
  if (store.state.config.storeId == 50 && value == "begin") {
    store.state.user.style_profile_key = "start";
    store_utils.emit_message({
      message: text,
      sender: "self",
      commit: true,
      logger: "onBoxButtonClick 1",
    }); // Affichage du choix sélectionné
    store.commit("SET_MODE", "style_profile");
    styleProfile.generateNextStyleProfileStep("begin");
    return;
  }

  if (store.state.config.storeId == 20) {
    // Manfield
    if (value == "start_reco") {
      store.state.user.style_profile_key = "start"; // Initialisation du step "start"
      store_utils.emit_message({
        message: text,
        sender: "self",
        commit: true,
        logger: "onBoxButtonClick 2",
      }); // Affichage du choix sélectionné
      store.commit("SET_MODE", "style_profile"); // Mode "size_mode" et modification du titre affiché
      styleProfile.generateNextStyleProfileStep("size_reco"); // Utilisation du bouton "size_reco" du step initialisé
      return;
    } else if (value == "first_suggestion") {
      // Si le choix sélectionné, depuis la minibox, est "first_suggestion"
      store.commit("SET_MODE", "chat"); // Activation du mode chat
      // Ne pas mettre de return pour que les conditions suivantes s'applique
    }
  }

  if (store.state.config.storeId == 38) {
    // Gilis
    if (value == "size_advice" || value == "begin") {
      store.state.user.style_profile_key = "start"; // Initialisation du step "start"
      store_utils.emit_message({
        message: text,
        sender: "self",
        commit: true,
        logger: "onBoxButtonClick 3",
      }); // Affichage du choix sélectionné
      store.commit("SET_MODE", "style_profile"); // Mode par défaut et modification du titre affiché
      if (value == "size_advice") {
        // Si le choix sélectionné, depuis la minibox, est "size_advice"
        styleProfile.generateNextStyleProfileStep("size_advice"); // Utilisation du bouton "size_advice" du step initialisé
      } else if (value == "begin") {
        styleProfile.generateNextStyleProfileStep("infos_orders");
      }
      return;
    } else if (value == "first_suggestion") {
      // Si le choix sélectionné, depuis la minibox, est "first_suggestion"
      store.commit("SET_MODE", "chat"); // Activation du mode chat
      // Ne pas mettre de return pour que les conditions suivantes s'applique
    }
  }

  if (store.state.config.storeId == 43) {
    // Cleed.ai
    store.state.user.style_profile_key = "start";
    store_utils.emit_message({
      message: text,
      sender: "self",
      commit: true,
      logger: "onBoxButtonClick 4"
    });
    if (value == "have_question") {
      store.commit("SET_MODE", "style_profile");
      styleProfile.generateNextStyleProfileStep("have_question");
    } else if (value == "information") {
      store.commit("SET_MODE", "style_profile");
      styleProfile.generateNextStyleProfileStep("information");
    } else if (value == "book_a_demo") {
      store.commit("SET_MODE", "style_profile");
      styleProfile.generateNextStyleProfileStep("book_a_demo");
    }
    return;
  }

  if (store.state.config.storeId == 49) {
    // Cleed.com
    if (
      [
        "first_suggestion",
        "begin",
        "start_reco",
        "go_search",
        "size_advice",
      ].includes(value)
    ) {
      store.state.user.style_profile_key = "start";
      if (value == "first_suggestion") {
        store.commit("SET_MODE", "chat");
      } else if (value == "begin") {
        store.commit("SET_MODE", "info_mode");
        styleProfile.generateNextStyleProfileStep("begin");
      } else if (value == "start_reco") {
        store.commit("SET_MODE", "your_mode");
        styleProfile.generateNextStyleProfileStep("recommendation");
      } else if (value == "go_search") {
        store.commit("SET_MODE", "search");
      } else if (value == "size_advice") {
        store_utils.emit_message({
          message: text,
          sender: "self",
          commit: true,
          logger: "onBoxButtonClick 5",
        });
        store.commit("SET_MODE", "size_mode");
        styleProfile.generateNextStyleProfileStep("size_reco");
      }
      store.state.config.appIsVisible = false;
    }
  }

  if (store.state.config.storeId == 53) {
    // CHANEL
    store.state.user.style_profile_key = "start";
    store_utils.emit_message({
      message: text,
      sender: "self",
      commit: true,
      logger: "onBoxButtonClick 6",
    });
    if (value == "have_question") {
      store.commit("SET_MODE", "style_profile");
      styleProfile.generateNextStyleProfileStep("have_question");
    }
    return;
  }

  if (store.state.config.storeId == 25 && value == "question") {
    store.state.user.style_profile_key = "start";
    store.state.user.data.condition = "question";
    store.commit("SET_MODE", "style_profile");
    styleProfile.generateNextStyleProfileStep("question");
    return;
  }

  if (text == "Voir mes recommandations" || text == "See my recommendations") {
    // customLogger("Recommendation tracked")
    matomoTracker.trackEvent("Chat", "New Step", "see_reco");
  }
  if (text == "Idées de cadeaux de Noël" || text == "Christmas gift ideas") {
    // customLogger("Christmas idea tracked")
    matomoTracker.trackEvent("Chat", "New Step", "christmas_idea");
  }
  if (value == "male" || value == "female") {
    store.commit("SET_GENDER", value);

    const send = {
      sender_type: "self",
      content: {
        message: text,
      },
      sent_at: At.toISOString(),
    };
    store.commit("PUSH_MESSAGE", send);
  } else if (
    value == "go_search" &&
    (store.state.config.storeId == "41" ||
      store.state.config.storeId == "16" ||
      store.state.config.storeId == "35" ||
      store.state.config.storeId == "40" ||
      store.state.config.storeId == "49")
  ) {
    // customLogger("MODE SEARCH")
    store.commit("SET_MODE", "search");
    return;
  } else if (
    value == "go_chat" &&
    (store.state.config.storeId == "41" ||
      store.state.config.storeId == "43" ||
      store.state.config.storeId == "46" ||
      store.state.config.storeId == "20" ||
      store.state.config.storeId == "38" ||
      store.state.config.storeId == "40" ||
      store.state.config.storeId == "47" ||
      store.state.config.storeId == "49" ||
      store.state.config.storeId == "51" ||
      store.state.config.storeId == "52" ||
      store.state.config.storeId == "25")
  ) {
    // customLogger("MODE CHAT")
    store.commit("SET_MODE", "chat");
    store_utils.emit_message({
      message: text,
      sender: "self",
      commit: true,
      logger: "onBoxButtonClick 7",
    });
    if (store.state.config.chat_config.chat_state.state == "active") {
      store_utils.emit_message({
        message: help_message,
        sender: "bot",
        commit: true,
        logger: "onBoxButtonClick 8",
      });
    }
    return;
  }

  if (store.state.config.storeId == 41) {
    store.commit("SET_MODE", "style_profile");
    if (store.state.user.style_profile_resume) {
      store.commit("STYLE_PROFILE_RESUME");
      store.dispatch("CURRENT_STYLE_PROFILE_STEP");
    } else {
      store.state.user.style_profile_key = "start";
      store.state.user.data.condition = value;
      styleProfile.generateNextStyleProfileStep(value);
    }
  }

  if (value == "start" && store.state.config.steps) {
    store.commit("SET_MODE", "style_profile");
    if (store.state.user.style_profile_resume) {
      store.commit("STYLE_PROFILE_RESUME");
      store.dispatch("CURRENT_STYLE_PROFILE_STEP");
      store.dispatch("SET_STYLE");
    } else {
      styleProfile.generateNextStyleProfileStep();
      store_utils.emit_message({
        message: text,
        commit: true,
      });
    }
  } else if (value == "noel" && store.state.config.steps) {
    store.commit("SET_MODE", "style_profile");
    if (store.state.user.style_profile_resume) {
      store.commit("STYLE_PROFILE_RESUME");
      store.dispatch("CURRENT_STYLE_PROFILE_STEP");
    } else {
      store.state.user.style_profile_key = "start";
      store.state.user.data.condition = "noel";
      styleProfile.generateNextStyleProfileStep("noel");
    }
  } else if (value == "solde" && store.state.config.steps) {
    customLogger("focus_solde");
    store.commit("SET_MODE", "style_profile");
    if (store.state.user.style_profile_resume) {
      customLogger("1");
      store.commit("STYLE_PROFILE_RESUME");
      store.dispatch("CURRENT_STYLE_PROFILE_STEP");
    } else {
      customLogger("2");
      store.state.user.style_profile_key = "start";
      store.state.user.data.condition = "soldes";
      styleProfile.generateNextStyleProfileStep("soldes");
    }
  } else if (value == "size_advice" && store.state.config.steps) {
    store.commit("SET_MODE", "style_profile");
    if (store.state.user.style_profile_resume) {
      store.commit("STYLE_PROFILE_RESUME");
      store.dispatch("CURRENT_STYLE_PROFILE_STEP");
    } else {
      store.state.user.style_profile_key = "start";
      store.state.user.data.condition = "size_advice";
      styleProfile.generateNextStyleProfileStep("size_advice");
    }
  } else if (
    value == "start_reco" &&
    (store.state.config.storeId == 37 || store.state.config.storeId == 33)
  ) {
    store.commit("SET_MODE", "style_profile");
    if (store.state.user.style_profile_resume) {
      store.commit("STYLE_PROFILE_RESUME");
      store.dispatch("CURRENT_STYLE_PROFILE_STEP");
    } else {
      store.state.user.style_profile_key = "start";
      store.state.user.data.condition = "recommendation";
      styleProfile.generateNextStyleProfileStep("recommendation");
    }
  } else if (
    value == "questions" &&
    (store.state.config.storeId == 37 || store.state.config.storeId == 33)
  ) {
    store.commit("SET_MODE", "style_profile");
    if (store.state.user.style_profile_resume) {
      store.commit("STYLE_PROFILE_RESUME");
      store.dispatch("CURRENT_STYLE_PROFILE_STEP");
    } else {
      store.state.user.style_profile_key = "start";
      store.state.user.data.condition = "questions";
      styleProfile.generateNextStyleProfileStep("questions");
    }
  } else if (value == "ask_email_from_question_answered") {
    const send = {
      sender_type: "bot",
      content: {
        message: i18n.get().tc("text.email"),
        form: get_ask_mail_form(),
      },
      typing_indicator: true,
      sent_at: At.toISOString(),
    };

    store.commit("PUSH_MESSAGE", send);
  } else if (value == "dont_ask_email_from_question_answered") {
    store.commit("PUSH_MESSAGE", {
      sender_type: "bot",
      content: "Ok",
      typing_indicator: true,
      sent_at: At.toISOString(),
    });
  } else {
    // customLogger("first suggestion PASS")
    store_utils.emit_message({
      message: text,
      commit: true,
      slack: true,
      dialogflow: true,
      ignoreGpt: true,
      is_first_proposition:
        value == "first_suggestion" ||
        value == "go_search" ||
        value == "go_chat",
    });
  }
}

function lexception_config(keyStore, value, text_without_t) {
  const step = [
    "brands_male_t-shirt",
    "brands_male_jacket",
    "brands_male_trench",
    "brands_male_coat",
    "brands_male_sweat",
    "brands_male_suits",
    "brands_male_shirts",
    "brands_male_trousers",
    "brands_male_jeans",
    "brands_male_jumpsuits",
    "brands_male_underwear",
    "brands_female_dress",
    "brands_female_skirts",
    "brands_female_t-shirt",
    "brands_female_jacket",
    "brands_female_trench",
    "brands_female_coat",
    "brands_female_sweat",
    "brands_female_shirts",
    "brands_female_trousers",
    "brands_female_jumpsuits",
    "brands_female_jeans",
    "brands_female_swimwear",
    "brands_female_sport",
    "brands_female_bras",
    "brands_female_bottom",
    "brands_female_body",
    "brands_female_homewear",
    "brands_female_hoisiery",
    "brands_female_hosiery",
    "get_brands_condition",
    "brands_male_sneakers",
    "brands_male_boots",
    "brands_male_derbies",
    "brands_male_sandals",
    "brands_male_espadrilles",
    "brands_female_sneakers",
    "brands_female_boots",
    "brands_female_derbies",
    "brands_female_sandals",
    "brands_female_espadrilles",
    "brands_female_pumps",
    "brands_female_ballerinas",
    "brands_male_bag",
    "brands_male_briefcases",
    "brands_male_small_leather",
    "brands_male_week-end_bags",
    "brands_male_high-tech",
    "brands_female_bag",
    "brands_female_goods",
    "brands_female_week-end_bags",
    "brands_female_high-tech",
    "brands_male_sunglasses",
    "brands_male_silks",
    "brands_male_hats",
    "brands_male_beanies",
    "brands_male_scarfs",
    "brands_male_gloves",
    "brands_male_belts",
    "brands_female_sunglasses",
    "brands_female_silks",
    "brands_female_beanies",
    "brands_female_scrafs",
    "brands_female_gloves",
    "brands_female_belts",
    "brands_male_goods",
    "brands_female_small_leather",
    "brands_female_hats",
    "style_necklaces",
    "style_watches",
    "style_deco",
    "style_hightech",
    "style_library",
    "style_delicatessen",
    "style_candles",
    "style_home",
  ];
  const brand_step = [
    "sub-sub-category-bag-male",
    "sub-sub-category-bag-female",
    "sub-sub-category-small-leather-male",
    "sub-sub-category-small-leather-female",
    "sub-sub-category-silks-male",
    "sub-sub-category-silks-female",
    "sub-sub-category-hats-male",
    "sub-sub-category-hats-female",
    "sub-sub-category-beanies-male",
    "sub-sub-category-beanies-female",
    "sub-sub-category-scarfs-male",
    "sub-sub-category-scarfs-female",
    "sub-sub-category-watches-male",
    "sub-sub-category-rings-male",
    "sub-sub-category-bracelets-male",
    "sub-sub-category-cuff-links-male",
    "sub-sub-category-necklaces",
    "sub-sub-category-watches-female",
    "sub-sub-category-rings-female",
    "sub-sub-category-bracelets-female",
    "sub-sub-category-cuff-links-female",
    "sub-sub-category-face_care",
    "sub-sub-category-soap",
    "sub-sub-category-haircare",
    "sub-sub-category-sun_care",
    "sub-sub-category-nailcare",
    "sub-sub-category-deco",
    "sub-sub-category-hightech",
    "sub-sub-category-library",
    "sub-sub-category-delicatessen",
    "sub-sub-category-candles",
    "sub-sub-category-home",
    "sub-sub-category-head_jewels",
    "usual_size_male",
    "usual_size_female",
    "shirts_size_male",
    "tops_size_female",
    "coats_size_male",
    "pants_size_male",
    "pants_size_female",
    "jeans_size_male",
    "jeans_size_female",
    "shoes_size_female",
    "shoes_size_male",
    "size_lingerie_female",
  ];

  const size_step = [
    "usual_size_male",
    "usual_size_female",
    "shirts_size_male",
    "tops_size_female",
    "coats_size_male",
    "pants_size_male",
    "pants_size_female",
    "jeans_size_male",
    "jeans_size_female",
    "shoes_size_female",
    "shoes_size_male",
    "size_lingerie_female",
  ];

  if (value === "restart" || value === "new") {
    // customLogger("reset")
    store.commit("RESET_QUIZ_OPTION");
    store.commit("SET_STYLE_PROFILE_KEY", null);
    store.state.user.data.to_save = { to_save: {} };
    delete store.state.user.data.last_step;
  }

  if (keyStore && keyStore.indexOf("sub-category") != -1) {
    if (keyStore.indexOf("sub-sub-category") != -1) {
      store.commit("SET_SUB_SUB_CATEGORY", text_without_t.split(".")[1]);
    } else {
      store.commit("SET_SUB_CATEGORY", value);
    }
  }

  if (keyStore && keyStore.search("brands") != -1) {
    for (let size of size_step) {
      for (let key of Object.keys(store.state.user.data)) {
        if (key === size) {
          let tmp_value = store.state.user.data[key];
          store.state.user.data[key] =
            store.state.user.data.get_brands_condition;
          store.state.user.data.get_brands_condition = tmp_value;
        }
      }
    }
  }

  for (let item_brand of brand_step) {
    if (keyStore === item_brand) {
      let tmp2 = "";
      if (store.state.user.data.sub_category != undefined) {
        tmp2 =
          "brands_" +
          store.state.user.data.gender +
          "_" +
          store.state.user.data.sub_category +
          "_step";
        store.commit("SET_SELECTED_BRANDS", tmp2);
        styleProfile.generateNextStyleProfileStep(tmp2);
      }
    }
  }

  for (let item of step) {
    if (keyStore === item) {
      let tmp = "";
      if (store.state.user.data.sub_category != undefined)
        tmp =
          "quiz_" +
          store.state.user.data.gender +
          "_" +
          store.state.user.data.sub_category +
          "_step";
      if (
        store.state.user.data.sub_category != undefined &&
        store.state.user.data.sub_sub_category != undefined
      )
        tmp =
          "quiz_" +
          store.state.user.data.gender +
          "_" +
          store.state.user.data.sub_category +
          "_" +
          store.state.user.data.sub_sub_category +
          "_step";
      // customLogger("tmp = ", tmp)
      store.commit("SET_SELECTED_QUIZ", tmp);
      styleProfile.generateNextStyleProfileStep(tmp);
    }
  }

  if (
    (keyStore === "FILTER" && value === "get_filter_condition") ||
    keyStore === "get_filter_condition"
  ) {
    let tmp3 = "";
    if (store.state.user.data.gender === "male") {
      tmp3 =
        "filter_" +
        store.state.user.data.gender +
        "_" +
        store.state.user.data.product_type_male +
        "_step";
    } else if (store.state.user.data.gender === "female") {
      tmp3 =
        "filter_" +
        store.state.user.data.gender +
        "_" +
        store.state.user.data.product_type_female +
        "_step";
    }
    store.commit("SET_SELECTED_FILTER", tmp3);
    styleProfile.generateNextStyleProfileStep(tmp3);
  }
}

async function changeStatusConversation() {
  const lastMessage =
    store.state.user.messages[store.state.user.messages.length - 1];

  // store.commit("SET_MODE", "chat");
  await store.dispatch("FETCH_USER_MESSAGES");
  apiRequest()
    .post("message/update", {
      id: store.state.user.conversation_id.toString(),
      status: "To check sto",
    })
    .then((data) => {
      customLogger("Change done", data);

      /**
       * @type {{
       *  storeId: string;
       *  id: string;
       *  conversation_id: number;
       *  guid: string;
       *  context: string;
       *  content: string;
       *  sent_at: string;
       *  status: string;
       * }}
       */
      const payload = {
        storeId: store.state.config.storeId,
        id: store.state.user.id,
        conversation_id: store.state.user.conversation_id,
        guid: store.state.user.guid,
        content: lastMessage.content,
        sent_at: lastMessage.sent_at,
        context: "chat",
        status: "To check sto",
      };

      // Send socket event after HTTP request so that we are sure the operatio
      // was allowed by the server, and persisted. We do not propagate invalid information.
      ss.socket.emit("ChangeStatusOfConversationFromBox", payload);
    });
}

async function onStyleButtonClick(
  { text, value, text_without_t, action, ai_question, live_coach_question },
  tmp_content = null
) {
  try{
  customLogger("onStyleButtonClick", { text, value, text_without_t, tmp_content, ai_question, action });
  //fomacast
  if (store.state.config.storeId == 59){
    if(value == 'resub'){
      store.dispatch("STOP_SUBSCRIPTION", "chat.resub");
      store.dispatch("FETCH_USER_MESSAGES");
      return
    }
    if(value == 'restart_sub'){
      customLogger("RESTART");
      const method = store.state.user.data.subscription.method;
      if(method == 'monthly'){
        customLogger("RESTART MONTHLY");
        store.state.user.loading_indicator = true
        await apiRequest().get("users/subscriptions/renew")
          .then(async () => {
            store.state.user.user_session = {}
            store.state.user.data = {}
            await store.dispatch("FETCH_USER_DATA", true);
            store.state.user.style_profile_key = null
            await store.dispatch("FETCH_USER_MESSAGES");
            store.state.user.loading_indicator = false
          })
          .catch((err) => {
            customLogger(err);
            store.state.user.loading_indicator = false
          }
        );
      }else{
        store.commit("PUSH_MESSAGE", {
          sender_type: "bot",
          content: {
            message: "chat.limit_non_monthly",
            buttons: [{name:"text.yes", value:"resub"}, {name:"text.no", value:"ending_phase"}],
            condition: { "resub": "resub", "ending_phase": "ending_phase" },
          },
        });
      }
      return
    }
  }
  let keyStore = store.state.user.style_profile_key;
  let obj_msg = store.state.user.messages[store.state.user.messages.length - 1];
  let to_send = null;
  let last_step = null;
  let help_message = "chat.help_inact";
  let ignoreGpt = true;

  // if store 87 
  if( store.state.config.storeId == 87 ) {
  
    // MFK 
    const mfkFlow = logicMFK(text,value, text_without_t, keyStore, obj_msg, to_send, last_step, ignoreGpt, help_message, tmp_content, action);
    return;
  }


  if (value == "productQuestion") {
    changeStatusConversation();
  }
  if (store.state.config.chat_config.chat_state.state == "active") {
    help_message = "chat.help";
  } else if (
    store.state.config.chat_config.chat_state.state == "not_reactive"
  ) {
    help_message = "chat.help_notreact";
  }
  if (keyStore === null) keyStore = "order_follow";

  customLogger(
    "MY VALUE => ",
    value,
    " + store_ID = ",
    store.state.config.storeId
  );

  if (store.state.config.storeId == "38" && value == "yes") {
    apiRequest()
      .post("message/update", {
        id: store.state.user.conversation_id.toString(),
        status: "Solved",
      })
      .then(() => {
        customLogger("Change done");
        //put emit to change the status right there
      })
      .catch((er) => {
        customLogger(er);
      });
  }

  if (store.state.config.storeId == 33 || store.state.config.storeId == 49) {
    lexception_config(keyStore, value, text_without_t);
  }

  // customLogger("user data = ", store.state.user.data)

  if (value == "close" || value == "closeButNextMessage") {
    store.commit("CLOSE_BOX");
  }
  if (
    value == "go_search" &&
    (store.state.config.storeId == 41 ||
      store.state.config.storeId == 35 ||
      store.state.config.storeId == 40)
  ) {
    customLogger("MODE SEARCH (style profile)");
    store.commit("SET_MODE", "search");
  } else if (
    value == "go_chat" &&
    (store.state.config.storeId == 20 ||
      store.state.config.storeId == 25 ||
      store.state.config.storeId == 35 ||
      store.state.config.storeId == 36 ||
      store.state.config.storeId == 38 ||
      store.state.config.storeId == 40 ||
      store.state.config.storeId == 43 ||
      store.state.config.storeId == 47 ||
      store.state.config.storeId == 49 ||
      store.state.config.storeId == 50 ||
      store.state.config.storeId == 51 ||
      store.state.config.storeId == 52 ||
      store.state.config.storeId == 53 ||
      store.state.config.storeId == 41 ||
      store.state.config.storeId == 46 ||
      store.state.config.storeId == 59 ||
      store.state.config.storeId == 57 
      )
  ) {
    //NOTE : activate it if the clinet asked 
    // if(store.state.config.storeId == 59 && store.state.user.questionCounter >= 10){
    //   store.commit("PUSH_MESSAGE", {
    //     sender_type: "bot",
    //     content: {
    //       message: "chat.force_10_points",
    //       buttons: [{name:"text.continue", value:"start_quizz"}],
    //     },
    //   });
    //   return
    // }
    customLogger("MODE CHAT");
    store.commit("SET_MODE", "chat");
    store_utils.emit_message({
      message: text,
      sender: "self",
      commit: true,
      ignoreGpt: true,
    });
    if(store.state.config.storeId == 59 && value == "go_chat" && store.state.user.data.subscription.method == 'monthly'){
      store.commit("PUSH_MESSAGE", {
        sender_type: "bot",
        content: "chat.choisi_formule",
      });
    }

    if (store.state.config.chat_config.chat_state.state == "active") {
      store_utils.emit_message({
        message: help_message,
        sender: "bot",
        commit: true,
        ignoreGpt: true,
      });
    }

    if (store.state.config.storeId ==  59){
      const step =
        store.state.config.steps["live_coach"];
      customLogger("step", step);
      if(step?.page_title?.title) {
        store.dispatch('setPageTitle', step.page_title.title);
      }
      if(step?.page_title?.subtitle) {
        store.dispatch('setPageSubtitle', step.page_title.subtitle);
      }
    }
    return;
  } else if (value == "whatsapp") {
    let whatsappUri = "https://web.whatsapp.com/send"; //for browsers
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      whatsappUri = "whatsapp://send"; //for mobiles
    }
    const phoneNumber = "0033780949086"; // add the brand phone number here
    const defaultText = `Bonjour, comment puis-je vous aider ? -- Hi, how i can help you ?`;
    /**
     * for default text if exist add this line:
     *  replare just YOUR_TEXT_HERE with you message !
     *       -> defaultText = `&text=YOUR_TEXT_HERE`
     **/
    const goal = `${whatsappUri}?phone=${phoneNumber}${defaultText}`;
    window.open(goal, "_blank");
  }

  if (Array.isArray(tmp_content) && tmp_content.length < 1) tmp_content = null;

  if (keyStore == "FILTER") {
    if (store.state.config.storeId == 33 || store.state.config.storeId == 49) {
      to_send = {
        filter: text,
      };
    } else {
      to_send = {
        filter: value,
      };
    }
  } else if (
    store.state.user.style_profile_prev_key == "FILTER" ||
    store.state.user.style_profile_prev_key === "get_filter_condition"
  ) {
    last_step = "FILTER";
    customLogger(
      "filter prev ",
      tmp_content ? tmp_content : value ? value : text
    );
    to_send = {
      filter: store.state.user.data.FILTER.filter,
      value: tmp_content
        ? tmp_content
        : value
          ? value
          : text_without_t.split(".")[1] || text_without_t,
    };
  } else if (keyStore == "gender") {
    store.commit("SET_GENDER", value);
  } else if (
    (obj_msg.content.carousel && obj_msg.content.carousel.mode === "explore") ||
    (obj_msg.content.look && obj_msg.content.look.mode === "explore")
  ) {
    store_utils.emit_message({
      message: text,
      commit: true,
      sender: "self",
      cb: () => {
        styleProfile.generateNextStyleProfileStep(
          tmp_content ? tmp_content : value ? value : text_without_t,
          to_send,
          last_step
        );
      },
    });
    return;
  }

  let payload
  if (store.state.config.chatgpt &&
     value == "fetch_next_product_explanation_button_ok" || 
     value == "fetch_next_product_explanation_button_cancel"){
        ignoreGpt = true;
        payload = obj_msg?.content?.payload;
  }

  delete obj_msg.content.button;

  store_utils.emit_message({
    message: obj_msg.content,
    sender: "bot",
    ignoreGpt,
    cb: async () => {
      await store_utils.emit_message({
        message: text,
        commit: true,
        sender: "self",
        ignoreGpt,
        cb: async () => {
          if (store.state.config.storeId == 59) {
            store.commit("SET_MODE", "style_profile");
            await formacastLogicMessage({ text, value, action, ai_question, live_coach_question, text_without_t, to_send, last_step, tmp_content }); 
          } else {
            styleProfile.generateNextStyleProfileStep(
              tmp_content ? tmp_content : value ? value : text_without_t,
              to_send,
              last_step
            );
          }
        },
      });
      //
      if (store.state.config.chatgpt) { 
        fetchNextProductExplanation(value, payload);
      }
    },
  });

  
  // customLogger("End of the methode ready for the next one\n")
  // customLogger("keyprev = ", store.state.user.style_profile_prev_key)
  } catch (e) {
    customLogger('StyleButtonClick -> e', e);
  }
}



async function fetchNextProductExplanation(value, payload) {

  try{
    if (value == "fetch_next_product_explanation_button_ok"){
      customLogger("!!!!fetch_next_product_explanation_button_[ok]!!!!!!!!!!!!", payload);
      if (payload) {
        payload.explanationMessage = 'chat.openai.fetch_next_product_explanation.preper_message'
        ss.socket.emit('ai_get_products_explination', {
          storeId: store.state.config.storeId,
          ...payload
        });
      }
    }else if(value == "fetch_next_product_explanation_button_cancel"){
      customLogger("!!!!fetch_next_product_explanation_button_[cancel]!!!!!!!!!!!!", payload);
      if (payload) {
        payload.just_feedback = true;
        ss.socket.emit('ai_get_products_explination', {
          storeId: store.state.config.storeId,
          ...payload
        });
      }
    }
  }catch(e){
    customLogger("fetchNextProductExplanation error", e)
  }
}

async function onBoxProductLike(product, liked) {
  const action = liked ? "add" : "remove";
  await apiRequest().patch("interactions/like", {
    action: action,
    product_id: product["product_id"],
  });
  if (window.matomoTracker) matomoTracker.trackEvent("Chat", "Like");
}

async function onBoxProductDislike(product, disliked) {
  // dislike mode
  const At = new Date();
  if (store.state.config.details["dislike_reason"] != "false") {
    // enable dislike mode
    store.commit("DISLIKE_MODE", true);
    if (disliked) {
      var default_buttons = [
        { name: "dislike.Style" },
        { name: "dislike.Pattern" },
        { name: "dislike.Color" },
        { name: "dislike.Material" },
        { name: "dislike.Detail" },
        { name: "dislike.Prices" },
      ];

      store.commit("PUSH_MESSAGE", {
        sender_type: "bot",
        content: {
          message: "dislike.message",
          product_card: product,
          alone: true,
          buttons: store.state.config.details.dislike_buttons
            ? store.state.config.details.dislike_buttons
            : default_buttons,
        },
        typing_indicator: false,
        sent_at: At.toISOString(),
      });
    }
  }

  store.commit("UPDATE_DATA", { tmp_content: product });
  const action = disliked ? "add" : "remove";
  await apiRequest().patch("interactions/dislikelist", {
    action: action,
    product_id: product["product_id"],
    ignoreGpt: true,
  });
  if (window.matomoTracker)
    matomoTracker.trackEvent("Chat", "Dislike", product.product_id);
}

function onBoxProductClick(product) {
  //matomo track
  if (window.matomoTracker) matomoTracker.trackEvent("Chat", "Product Clicked");
  utils.openInTab(product.url);
}

function onBoxImageClick(item) {
  if (window.matomoTracker) matomoTracker.trackEvent("Chat", "Image Clicked");
}

function onStyleImageClick(item) {
  // Style step
  // customLogger("onStyleImageClick", item);

  store_utils.emit_message({
    message:
      store.state.user.messages[store.state.user.messages.length - 1].content,
    sender: "bot",
    cb: () => {
      store_utils.emit_message({
        message: i18n.get().tc(item.name),
        commit: true,
      });
      styleProfile.generateNextStyleProfileStep(item.name);
    },
  });
}

function onBoxGridSelected(item) {}

function onStyleGridSelected(item) {
  // Quiz step
  // save item ? maybe
  // customLogger(store.state.user.style_profile_key, item);
  store_utils.emit_message({
    message:
      store.state.user.messages[store.state.user.messages.length - 1].content,
    sender: "bot",
  });
  styleProfile.generateNextStyleProfileStep(item);
}

function onBoxSubmittedForm(values) {}

function onStyleSubmittedForm(response, values, next) {
  store_utils.emit_message({
    message:
      store.state.user.messages[store.state.user.messages.length - 1].content,
    sender: "bot",
    cb: () => {
      store_utils.emit_message({
        message: response.content,
        commit: true,
        sender: "bot",
        cb: () => {
          if (next) {
            styleProfile.generateNextStyleProfileStep(values);
          } else {
            store.dispatch("CURRENT_STYLE_PROFILE_STEP");
          }
        },
      });
    },
  });
}

function onBoxLookingForSimilar(product, store_id, count, shift) {
  const At = new Date();
  store.commit("PUSH_MESSAGE", {
    sender_type: "bot",
    content: {
      message: "Recherche en cours, un instant s'il vous plaît",
    },
    typing_indicator: true,
    sent_at: At.toISOString(),
  });

  // API request
  api
    .sauron_lookup(product, store_id, count, shift)
    .then((res) => {
      if (res.data[4]["similar products"]) {
        let raw_data = res.data[4]["similar products"];
        let products_list = [];
        let At = new Date();
        let tmp = {};
        raw_data.forEach((item) => {
          tmp = {};

          tmp.picture_url = item.picture_url;
          tmp.url = item.url;
          tmp.name = item.name;
          tmp.brand = "";
          tmp.price = isNaN(parseFloat(item.price))
            ? parseFloat(item.price)
            : "**.*";
          tmp.price_old = isNaN(parseFloat(item.price_old))
            ? parseFloat(item.price_old)
            : "**.*";

          tmp.is_similarity_result = true;

          // customLogger(tmp.url)
          products_list.push(tmp);
        });

        store.commit("PUSH_MESSAGE", {
          sender_type: "bot",
          content: {
            message: "Voici des produits similaires",
            carousel: {
              type: "products",
              values: products_list,
            },
            alone: false,
            buttons: [{ name: "text.seeMore" }],
          },
          typing_indicator: false,
          sent_at: At.toISOString(),
        });
      } else {
        store.commit("PUSH_MESSAGE", {
          sender_type: "bot",
          content: {
            message:
              "Selon notre système automatisé, aucun produit ne semble être très similaire visuellement à celui-ci",
          },
          buttons: [{ name: "text.seeMore" }],
          typing_indicator: true,
          sent_at: At.toISOString(),
        });
      }
    })
    .catch((err) => {
      customLogger(
        "[Cleed] - Could not retrieve data for similar products",
        err
      );

      store.commit("PUSH_MESSAGE", {
        sender_type: "bot",
        content: {
          message:
            "La recherche par images ne semble pas être disponilble pour le moment",
        },
        typing_indicator: false,
        sent_at: At.toISOString(),
      });

      styleProfile.generateNextStyleProfileStep("seeMore");
    });
}

function onPopUpButtonClick(button) {
  if (button.value === "close") {
    store.commit("CLOSE_POPUP");
  } else {
    customLogger("ELSE PASS");
    store.dispatch("OPEN_BOX");
    customLogger("BUTON: ", button);
    onBoxButtonClick(button);
  }
}

function onPopUpClose() {
  store.commit("CLOSE_POPUP");
}

function onChatSearch(data) {
  delete store.state.user.messages[store.state.user.messages.length - 1].content
    .button;
  // save message
  store_utils.emit_message({
    message: data.gender.text,
    slack: true,
    sender: "self",
    cb: () => {
      data.gender = data.gender.value;
      ss.socket.emit("search_products", data);
    },
  });
}

function get_ask_mail_form() {
  return {
    inputs: [
      {
        name: "Email",
        value: "email",
        type: "email",
        required: "true",
      },
      {
        name: "signup.confidentiality",
        href: specs.TERMS_URL,
        value: "confidentiality",
        type: "checkbox",
        required: "true",
        class: "chat-small",
      },
    ],
    submit_text: "ok",
    on_click: "ChatEmailInput",
  };
}

function get_ask_gender() {
  return [
    { name: "gender.female", value: "female" },
    { name: "gender.male", value: "male" },
  ];
}

function onSlackMessageDeleted(data) {
  store.commit("Message_live_change", {
    action: "delete",
    id: data.data.id_msg,
  });
}

function onUpdateChatConfig() {
  setTimeout(() => {
    let last_msg_content =
      store.state.user.messages[store.state.user.messages.length - 1].content;
    let last_msg_content_lower =
      last_msg_content instanceof Object
        ? last_msg_content?.message?.toLowerCase()
        : last_msg_content?.toLowerCase();
    let current_mode = store.state.config.chat_config.chat_state.state;
    var ihavequestion = [
      "j'ai une question",
      "j'ai une autre question",
      "i have a question",
      "i have an other question",
      "popup.proposition2",
    ];
    let At = new Date();

    if (
      store.state.navigation.mode == "chat" &&
      (store.state.user.messages.length > 1 ||
        ihavequestion.includes(last_msg_content_lower)) &&
      store.state.config.storeId != 26
    ) {
      if (
        current_mode === "no-active" &&
        (last_msg_content != "chat.not_here" || last_msg_content != "chat.not_here_thumb_down") &&
        (last_msg_content.message != "chat.not_here" || last_msg_content.message != "chat.not_here_thumb_down")
      ) {
        const new_msg_content = store.state.config?.chat_config?.thumb_down_feedback ? "chat.not_here_thumb_down" : "chat.not_here";
        let new_msg = {
          content: new_msg_content,
          typing_indicator: true,
          sender_type: "bot",
          sent_at: At.toISOString(),
        };
        store.state.user.style_profile = false;
        customLogger("not here", new_msg);
        store.state.user.messages.push(new_msg);
      } else if (
        current_mode === "active" &&
        last_msg_content != "chat.help" &&
        last_msg_content != "chat.first" &&
        last_msg_content.message != "chat.first" &&
        last_msg_content != "message.size_reco" &&
        store.state.user.messages[store.state.user.messages.length - 1]
          .sender_type != "admin"
      ) {
        let new_msg = {
          content: "chat.help",
          typing_indicator: true,
          sender_type: "bot",
          sent_at: At.toISOString(),
        };
        store.state.user.style_profile = true;
        store.state.user.messages.push(new_msg);
      }
    }
  }, 2000);
}

function onSkipEmailMessage(step) {
  //change the chat state to active if chatGpt is enabled
  if (store.state.config.chatgpt)
    store.state.config.chat_config.chat_state.state = "active";

  if (step){
    styleProfile.generateNextStyleProfileStep(step);
  }

  // remove last message in store.state.user.message array "not-here"
  store.state.user.messages.pop();
}



function logicMFK(text,value, text_without_t, keyStore, obj_msg, to_send, last_step, ignoreGpt, help_message, tmp_content, action){
  const lang = store.state.user.lang;

  if (value === "start_over") {
    customLogger("reset")
    store.commit("RESET_QUIZ_OPTION");
    store.commit("SET_STYLE_PROFILE_KEY", null);
    store.state.user.data.to_save = { to_save: {} };
    delete store.state.user.data.last_step;
  }

  customLogger("MFK LOGIC \n", "text : ", text +  "\n", 
  "value : ", value + "\n",
  "text_without_t : ", text_without_t + "\n",
  "keyStore : ", keyStore + "\n",
  "obj_msg : ", obj_msg + "\n",
  "to_send : ", to_send + "\n", 
  "last_step : ", last_step + "\n",
  "ignoreGpt : ", ignoreGpt + "\n",
  "help_message : ", help_message + "\n",
  "tmp_content : ", tmp_content + "\n",
  "action : ", action + "\n"
  )
  if(action?.type == 'multiSubmit'){
    const multiTextTemplate = (text)=>{
      const templates = {
        "en" : `Let's continue with : ${text}`,
        "fr" : `Continuons avec : ${text}`
      }
      return templates[lang]
    }
    store_utils.emit_message({
      message: multiTextTemplate(text),
      commit: true,
      sender: "self",
      cb: () => {
        styleProfile.generateNextStyleProfileStep(value);
      },
    });
    return
  }

  const continueTextTemplate =(text)=>{
    const templates  = {
      "en": [
        `I choose to continue with : ${text}.`
      ],
      "fr":[
        `Je choisis de continuer avec : ${text}.`
      ]
    }
    return templates[lang][Math.floor(Math.random() * templates[lang].length)];
  }

  if(action?.type == 'random_select'){
   

    const randomSelectValues  = action.options
    customLogger(randomSelectValues);
    const nextStep = randomSelectValues[Math.floor(Math.random() * randomSelectValues.length)];

    // push message
    const i18nText = i18n.get().tc(nextStep.text);
    store_utils.emit_message({
      message:continueTextTemplate(i18nText),
      commit: true,
      sender: "self",
      cb: () => {
        styleProfile.generateNextStyleProfileStep(nextStep.value);
      },
    });
    return

  }

  customLogger("CRRUENT =====> ",keyStore)
  const selectionValues = [
    "gift_selection",
    "gift_type_selection",
    "opt_for",
    "recipient_selection",
    "bath_body_gift_type",
    "art_living_gift_type",
    "scent_intensity_selection",
    "scent_selection",
  ]
  if(selectionValues.includes(keyStore)){
    store_utils.emit_message({
      message:continueTextTemplate(text),
      commit: true,
      sender: "self",
      cb: () => {
        styleProfile.generateNextStyleProfileStep(value);
      },
    });
    return
  }

  
  styleProfile.generateNextStyleProfileStep(value);
  return false
}